<div [ngClass]="fromDialog?'':'fullScreen'">
    <h2>{{moduleName |translate}} - {{pageName |translate}}</h2>
    <vias-form 
      #form
      [tabs]="tabs"
      [hasSubmitBtn]="hasSubmitBtn"
      [submitBtnText]="submitBtnText"
      [numLocale]="numLocale"
      [formItems]="formItems"
      (formChange)="formChangeHandler($event)"
      (formSubmit)="formSubmitHandler($event)"
      (formItemClick)="formItemClickHandler($event)"
    ></vias-form>
    <vias-datagrid
      [dataSource]="dataSource"
      [numLocale]="numLocale"
      [columns]="columns"
      [currentPage]="pageno"
      [totalPages]="totalPages"
      [options]="datagridOptions"
      [rowClassRules]="rowClassRules"
      [tableId]="datagridId"
      [sideMenuItems]="sideMenuItems"
      [contextMenuItems]="contextMenuItems"
      (refresh)="datagridRefreshHandler($event)"
      (rowClick)="datagridClickHandler($event)"
      (dblClick)="datagridDoubleClickHandler($event)"
      (selectClick)="datagridSelectBtnClickHandler($event)"
      (addClick)="datagridAddBtnClickHandler($event)"
      (editClick)="datagridEditBtnClickHandler($event)"
      (deleteClick)="datagridDeleteBtnClickHandler($event)"
      [columnState]="datagridColumnState"
      (columnStateChange)="datagridColumnStateChangeHandler($event)"
      [dgButtons]="dgButtons"
    ></vias-datagrid>
    <vias-buttonbar
      [numLocale]="numLocale"
      [buttons]="buttonBarItems"
      (itemClick)="butonclickHandler($event)"
      *ngIf="hasButtonbar"
    ></vias-buttonbar>
  </div>